"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "modica": {
    "2282a17a": [{
      "hkey": "8700e0a2",
      "slug": "frigintini-gianforma",
      "name": "Frigintini-Gianforma",
      "primary": true,
      "skipSearch": false
    }],
    "frigintini": [{
      "hkey": "8700e0a2",
      "slug": "frigintini-gianforma",
      "name": "Frigintini-Gianforma",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;